import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import * as React from 'react';
import { WebimManager } from '../../services/WebimManager';
import { Close } from '../Close';
import * as styles from './styles.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var WebimChat = /*#__PURE__*/function (_React$Component) {
  function WebimChat() {
    var _this;
    _classCallCheck(this, WebimChat);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, WebimChat, [].concat(args));
    _defineProperty(_this, "webim", void 0);
    return _this;
  }
  _inherits(WebimChat, _React$Component);
  return _createClass(WebimChat, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        accountName = _this$props.accountName,
        _this$props$host = _this$props.host,
        host = _this$props$host === void 0 ? 'webim.ru' : _this$props$host,
        location = _this$props.location;
      this.webim = new WebimManager(accountName, {}, host, location);
      this.initWebimManager();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var isOpen = this.props.isOpen;
      if (prevProps.isOpen !== isOpen) {
        if (isOpen) {
          this.webim.start();
        } else {
          this.webim.close();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_jsxs("div", {
        className: styles['container'],
        children: [/*#__PURE__*/_jsx("iframe", {
          id: "webim-chat-iframe"
        }), /*#__PURE__*/_jsx(Close, {
          onClick: this.props.onClose
        })]
      });
    }
  }, {
    key: "initWebimManager",
    value: function () {
      var _initWebimManager = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this$props2, _this$props2$userData, userData, onReady;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this$props2 = this.props, _this$props2$userData = _this$props2.userData, userData = _this$props2$userData === void 0 ? null : _this$props2$userData, onReady = _this$props2.onReady;
              if (userData) {
                this.webim.setUser(userData);
              }
              _context.prev = 2;
              _context.next = 5;
              return this.webim.init();
            case 5:
              /* istanbul ignore else */
              if (onReady) {
                onReady();
              }
              _context.next = 10;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](2);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[2, 8]]);
      }));
      function initWebimManager() {
        return _initWebimManager.apply(this, arguments);
      }
      return initWebimManager;
    }()
  }]);
}(React.Component);